<template lang="pug">
v-btn(v-if="hasDiscount", @click="handleRemove", :loading="loading", color="error", small, outlined) Remove Discount
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    order: { type: Object, required: true },
  },
  computed: {
    hasDiscount() {
      return this.order?.dishes?.some(d => d.pctOff > 0)
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    ...mapActions(["updateOrder"]),
    handleRemove() {
      confirm("Are you sure you want to remove the discount?") && this.proceed()
    },
    async proceed() {
      this.loading = true
      const params = {
        orderId: this.order._id,
        discounts: this.order.dishes.map(() => 0), // reset all discounts
        reason: 'Reset Discount by Selflane'
      }
      try {
        const result = await this.$api.order.custom('discountDishes', params)
        this.updateOrder(result)
        this.$toast.success("Discount removed")
      } catch (e) {
        this.$toast.error(e.message)
      } finally {
        this.loading = false
      }
    },
  },
};
</script>